"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'autocomplete.triggers.suggestions': 'Elementos disponibles',
    'autocomplete.triggers.noResults': 'No se encontraron elementos coincidentes',
    'autocomplete.triggers.stylesPlaceholder': 'Escriba / para buscar estilos...',
    'autocomplete.triggers.projectsPlaceholder': 'Escriba # para buscar proyectos...',
    'autocomplete.triggers.knowledgePlaceholder': 'Escriba @ para buscar conocimiento...',
    'autocomplete.triggers.loading': 'Cargando...',
    'autocomplete.triggers.error': 'Error al cargar sugerencias',
};
